<template lang="html">
  <div>
    <v-container pa-0 fluid>
      <v-row align="center" justify="space-between" class="font-weight-black Barra_Breadcrumbs">
        <v-col cols="12">
          <v-breadcrumbs :items="breadcrumbs" divider="/">
            <v-breadcrumbs-item
              slot="item"
              slot-scope="{ item }"
              :key="item.nivel"
              :disabled="item.disabled"
              @click.native="navegarBreadcrumbs(item)">
                {{ item.text }}
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-col>
      </v-row>
    </v-container>

    <v-tabs
      centered
      class="NotasTabs elevation-1"
      :grow="isDetalhadoAtivo"
      v-model="tabSelecionada">

      <v-tab href="#tab-consolidado" v-if="!isInconsistencia">
        {{ $tc('label.consolidado', 2) }}
      </v-tab>
      <v-tab href="#tab-detalhado" v-if="!isInconsistencia" :disabled="!tituloNotaSelecionada">
        {{ $t('label.detalhado') }} {{ tituloNotaSelecionada ? '- ' + tituloNotaSelecionada : '' }}
      </v-tab>
      <v-tab href="#tab-faturamento" v-if="isInconsistencia">
        {{ $t('label.faturamento') }}
      </v-tab>
      <v-tab href="#tab-devolucao" v-if="isInconsistencia">
        {{ $tc('label.devolucao', 2) }}
      </v-tab>
      <v-tab href="#tab-pedido" v-if="isInconsistencia">
        {{ $t('label.pedido') }}
      </v-tab>

      <v-tabs-items v-model="tabSelecionada">
        <v-tab-item id="tab-consolidado" v-if="!isInconsistencia">
          <notas-lista-consolidado
            :visao="visao"
            :key="visao"
            v-show="tabSelecionada === 'tab-consolidado'"
            @Notas__SelecionaItemNivel2="selectItem"></notas-lista-consolidado>
        </v-tab-item>

        <v-tab-item id="tab-detalhado" v-if="!isInconsistencia">
          <notas-lista-detalhado
            :visao="visao"
            :notaSelecionada="notaSelecionada"
            v-show="isDetalhadoAtivo"></notas-lista-detalhado>
        </v-tab-item>

        <v-tab-item id="tab-faturamento" v-if="isInconsistencia">
          <notas-lista-inconsistencia
            visao="Faturamento"
            v-show="tabSelecionada === 'tab-faturamento'"></notas-lista-inconsistencia>
        </v-tab-item>

        <v-tab-item id="tab-devolucao" v-if="isInconsistencia">
          <notas-lista-inconsistencia
            visao="Devoluções"
            v-show="tabSelecionada === 'tab-devolucao'"></notas-lista-inconsistencia>
        </v-tab-item>

        <v-tab-item id="tab-pedido" v-if="isInconsistencia">
          <notas-lista-inconsistencia
            visao="Pedido"
            v-show="tabSelecionada === 'tab-pedido'"></notas-lista-inconsistencia>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex';
import { generateComputed } from '../../produto/common/functions/roles-computed-generator';
import notasListaConsolidado from './NotasNivel2DadosListaConsolidado';
import notasListaDetalhado from './NotasNivel2DadosListaDetalhado';
import notasListaInconsistencia from './NotasNivel2DadosInconsistenciaAgrupado';

export default {
  name: 'Notas',
  data() {
    return {
      tabSelecionada: 'tab-consolidado',
      visao: '',
      notaSelecionada: {},
      breadcrumbs: [],
      tituloNotaSelecionada: null,
    };
  },
  watch: {
    tabSelecionada: {
      handler() {
        if (this.tabSelecionada !== 'tab-detalhado') {
          this.tituloNotaSelecionada = null;
          if (this.breadcrumbs.length === 3) {
            this.breadcrumbs.splice(2, 1);
          }
        }
      },
    },
  },
  computed: {
    ...mapGetters('implantacao', [
      'indModoVarejo',
    ]),
    ...generateComputed('NOTA', [
      'canAccessPage',
      'canAccessCRUD',
    ]),

    isSellIn() {
      if (this.visao === 'Faturamento') {
        return true;
      }
      return false;
    },

    isDevolucao() {
      if (this.visao === 'Devoluções') {
        return true;
      }
      return false;
    },

    isPedidoCarteira() {
      if (this.visao === 'Pedido em Carteira') {
        return true;
      }
      return false;
    },

    isPedidoRemessa() {
      if (this.visao === 'Pedido em Remessa') {
        return true;
      }
      return false;
    },

    isDetalhadoAtivo() {
      if (this.tabSelecionada === 'tab-detalhado') {
        return true;
      }
      return false;
    },
    isInconsistencia() {
      if (this.visao === 'Inconsistências') {
        return true;
      }
      return false;
    },
  },
  components: {
    notasListaConsolidado,
    notasListaDetalhado,
    notasListaInconsistencia,
  },
  methods: {
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast('Acesso negado');
      }
    },
    navegarBreadcrumbs(item) {
      if (item.disabled) {
        return;
      }
      this.breadcrumbs.splice(1, 1);
      this.$router.push({ name: item.to });
    },
    selectItem(item) {
      this.adicionarItemBreadcrumbs(item);
      this.notaSelecionada = item;
      this.tabSelecionada = 'tab-detalhado';
    },
    adicionarItemBreadcrumbs(item) {
      if (this.breadcrumbs.length === 3) {
        this.breadcrumbs.splice(2, 1);
      }
      let caminhoItem = '';

      caminhoItem = item
        .competencia
        .concat(' :: ')
        .concat(item.cod_cliente || item.codCliente)
        .concat(' - ')
        .concat(item.nom_cliente || item.nomCliente || item.nomeCliente);

      this.tituloNotaSelecionada = caminhoItem;
      this.breadcrumbs.push({
        text: caminhoItem,
        value: item,
        to: 'nivel2Notas',
        disabled: true,
        nivel: 3,
      });
    },
  },
  beforeMount() {
    if (!this.$route.params.visao) {
      this.$router.push({ name: 'notas' });
    } else {
      this.visao = this.$route.params.visao;
      this.breadcrumbs = this.$route.params.breadcrumbsParam;
      this.breadcrumbs[1].disabled = true;
    }
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
    if (this.isInconsistencia) {
      this.tabSelecionada = 'tab-faturamento';
    }
  },
};
</script>

<style lang="scss">
  .Barra_Breadcrumbs {
    .v-breadcrumbs {
      padding: 0.5em 0 1em 0;
    }
    .v-breadcrumbs__item {
      font-size: 1.2em;
      cursor: pointer;
    }
    .v-breadcrumbs__item--disabled {
      cursor: default
    }
    ul:not(.md-list)>li+li {
      margin-top: 0 !important;
    }
  }

  .NotasTabs .theme--light.v-expansion-panel--focusable .v-expansion-panel__container:focus {
    background-color: white;
  }

  .NotasTabs .v-tabs__div {
    max-width: 100%;
  }

  .NotasTabs .v-tabs__bar {
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
  }

  .NotasTabs .v-tabs__slider {
    height: 3px;
  }
</style>
